// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ref-link[data-v-5671eb3e]{color:#ff4f36;background-color:#fff;width:100%;display:block;text-align:center;height:100%;line-height:50px}.close-banner[data-v-5671eb3e]{position:absolute;top:2px;right:2px;font-size:20px;border-radius:50%;border:1px solid #000;height:20px;width:20px;line-height:17px;text-align:center;font-weight:bolder;color:#000}img[data-v-5671eb3e]{width:100vw}", ""]);
// Exports
module.exports = exports;
